// NPM Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Loader, Toastr, Button, Input } from "@revvsales/components";

// Actions Imports
import CommonActions from "../../actions/CommonActions";

// Internal Imports
import { GRID } from "../../constants";
import { GlobalUtils } from "../../utils";

// Destructuring
const { GRID_ADMIN_ROLES } = GRID;
const { getColVisibility, updateColVisibility } = CommonActions;
const { camelCaseToSpace } = GlobalUtils;

class AgGridVisibilityCtrl extends Component {
  state = {
    showLoader: true,
    visibilityInfo: [],
  };

  componentDidMount() {
    this._onInit();
  }

  _onInit = () => {
    this.props.getColVisibility(this.props.page).then(res => {
      this.setState({ visibilityInfo: res, showLoader: false });
    });
  };

  _handleOnChange = (colIndex, role) => {
    // Change the role inside a column dynamically
    const cloneState = { ...this.state.visibilityInfo };
    const roleInfo = cloneState.data[colIndex].options[role];
    roleInfo.visible = !roleInfo.visible;
    this.setState(() => ({ visibilityInfo: cloneState }));
  };

  _onSubmit = () => {
    const { visibilityInfo } = this.state;
    const payload = {};
    visibilityInfo.roles.forEach(role => {
      const columnStatus = {};
      visibilityInfo.data.forEach(list => {
        columnStatus[list.id] = list.options[role.id].visible;
      });
      payload[role.id] = columnStatus;
    });
    this.props.updateColVisibility(payload, this.props.page).then(() => {
      this.props.togglePopUp();
      Toastr.showToastr({
        type: "success",
        message: "Roles Update Successful!",
        timeout: 2000,
      });
    });
  };

  _returnTitle = () =>
    this.state.visibilityInfo.titles.map(title => {
      if (!GRID_ADMIN_ROLES.includes(title) && title) {
        return (
          <div className="aggridvisibilityctrl-header-title" key={title}>
            {camelCaseToSpace(title)}
          </div>
        );
      }
      return null;
    });

  _returnRoleStatus = () =>
    this.state.visibilityInfo.data.map((col, index) => (
      <div className="aggridvisibilityctrl-row" key={col.title}>
        <div className="aggridvisibilityctrl-row-roles">{col.title}</div>
        {col.options.map(role => {
          if (!GRID_ADMIN_ROLES.includes(role.name)) {
            return (
              <div className="aggridvisibilityctrl-row-roles" key={role.id}>
                {/* <div>{role.id}</div>
                  <div>{role.visible}</div> */}
                <Input
                  checked={role.visible}
                  name="role"
                  onChange={() => this._handleOnChange(index, role.id)}
                  type="checkbox"
                  value=""
                  data-test="aggridvisibilityctrl-input"
                />
              </div>
            );
          }
          return null;
        })}
      </div>
    ));

  render() {
    const { visibilityInfo, showLoader } = this.state;
    const { title } = this.props;
    return (
      <div>
        <section>{showLoader && <Loader />}</section>
        <section>
          {!showLoader && visibilityInfo && visibilityInfo.data && (
            <div className="aggridvisibilityctrl-container">
              <div className="aggridvisibilityctrl-title">
                {title}
                <div className="aggridvisibilityctrl-description">
                  You can manage the visibility of the columns based on roles
                </div>
              </div>
              <div className="aggridvisibilityctrl-header">
                {this._returnTitle()}
              </div>
              <div className="aggridvisibilityctrl-list">
                {this._returnRoleStatus()}
              </div>
              <div className="aggridvisibilityctrl-footer">
                <div className="footer-actions">
                  <Button
                    className="btn btn-primary"
                    type="button"
                    onClick={this._onSubmit}
                    data-test="aggridvisibilityctrl-save-btn">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}

AgGridVisibilityCtrl.propTypes = {
  page: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  getColVisibility,
  updateColVisibility,
};

export default connect(
  null,
  mapDispatchToProps,
)(AgGridVisibilityCtrl);



// WEBPACK FOOTER //
// ./src/components/AgGridVisibilityCtrl/AgGridVisibilityCtrl.js